/* file description */

import React, { useRef, forwardRef, useImperativeHandle, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';

import { ProFormInstance, EditableProTable, EditableFormInstance } from '@cui/pro-components';
// import { SPFormBase } from '../../../SPForm';
import { BetaSchemaForm as SPFormBase } from '@cui/pro-components';

import {
  useAddRecordForm,
  useAddRecordWrap,
  useColumnsProp,
  useEditableProp,
  usePaginationProp,
  useRowKeyProp,
  useSearchProp,
  useToolBarRender,
  useOptionProp,
  useRecordCreatorProp,
  useColumnsState,
} from './effect';

import type { XtableBaseProps, XTableRef } from './type';

export const SPTableBase: ForwardRefExoticComponent<PropsWithoutRef<XtableBaseProps> & RefAttributes<XTableRef>> = forwardRef<XTableRef, XtableBaseProps>(
  (
    {
      autoRowEditConfig,
      autoAddRecordConfig,
      editable,
      search,
      pagination,
      toolBarRender,
      request,
      rowKey,
      columns,
      tableBaseMode,
      params,
      options,
      recordCreatorProps,
      optionColumns,
      columnsState,
      defaultColumnsState,
      actionRef,
      getRowsData,
      tableDataEdit,
      autoPopUp,
      showTableIndex,
      rowsData,
      onChange,
      onSubmit,
      onReset,
      onTableChange,
      ...otherProps
    },
    ref,
  ) => {
    // 内置功能处理 - start
    const editableFormRef = useRef<EditableFormInstance<any> | undefined>();
    // const effectFormRef = useRef()
    const { addRecordWrapVisible, setAddRecordWrap } = useAddRecordWrap();
    const { mergeRecordFormType, mergeRecordFormColumns } = useAddRecordForm({
      recordFormType: autoAddRecordConfig?.recordFormType,
      columns,
      steps: autoAddRecordConfig?.steps,
    });
    // 内置功能处理 - end

    // 属性封装处理 - start
    const mergeSearch = useSearchProp({ search });
    const mergeColumns = useColumnsProp({ columns, autoRowEditConfig, rowKey, tableBaseMode, optionColumns, showTableIndex });
    const mergeEditable = useEditableProp({ editable, actionRef, request, autoRowEditConfig, rowsData, rowKey, getRowsData, tableDataEdit });
    // const mergePagination = usePaginationProp({ pagination });
    const mergeRowKey = useRowKeyProp({ rowKey });
    const mergeToolBarRender = useToolBarRender({
      toolBarRender,
      setAddRecordWrap,
      autoAddRecordConfig,
      addRecordWrapVisible,
      tableBaseMode,
      autoPopUp,
    });
    const mergeOptions = useOptionProp({ options });
    const mergeRecordCreatorProps = useRecordCreatorProp({ recordCreatorProps });
    const mergeColumnsState = useColumnsState({ columnsState, defaultColumnsState });
    // 属性封装处理 - end

    // ref转发
    useImperativeHandle(ref, () => ({
      tableAction: actionRef.current,
      queryForm: editableFormRef.current,
    }));

    return (
      <>
        <EditableProTable
          options={mergeOptions}
          recordCreatorProps={mergeRecordCreatorProps}
          params={params}
          dateFormatter="string"
          editable={mergeEditable}
          search={mergeSearch}
          actionRef={actionRef}
          editableFormRef={editableFormRef}
          pagination={pagination}
          cardBordered
          toolBarRender={mergeToolBarRender}
          request={request}
          columns={mergeColumns}
          rowKey={mergeRowKey}
          columnsState={mergeColumnsState}
          {...otherProps}
          value={rowsData}
          onChange={onChange}
          onSubmit={onSubmit}
          onReset={onReset}
          onTableChange={onTableChange}
        />
        <SPFormBase
          layoutType={mergeRecordFormType}
          columns={mergeRecordFormColumns}
          visible={addRecordWrapVisible}
          drawerProps={
            mergeRecordFormType === 'DrawerForm'
              ? {
                title: autoAddRecordConfig?.formTitle || '新增',
                destroyOnClose: true,
                onClose: () => setAddRecordWrap(false),
              }
              : undefined
          }
          modalProps={
            mergeRecordFormType === 'ModalForm'
              ? {
                title: autoAddRecordConfig?.formTitle || '新增',
                destroyOnClose: true,
                onCancel: () => setAddRecordWrap(false),
              }
              : undefined
          }
          onFinish={async (values) => {
            await autoAddRecordConfig?.onSave(values);
            setAddRecordWrap(false);
            actionRef.current?.reload();
          }}
        />
      </>
    );
  },
);

export default SPTableBase;
